/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Extraordinary_ReasonInputs */

const en_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason for extraordinary termination`)
};

const de_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund der außerordentlichen Kündigung`)
};

const fr_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motif de résiliation extraordinaire`)
};

const es_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo de la terminación extraordinaria`)
};

const it_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo della risoluzione straordinaria`)
};

const nl_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reden voor buitengewone opzegging`)
};

const pl_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powód wypowiedzenia nadzwyczajnego`)
};

const fi_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poikkeuksellisen irtisanomisen syy`)
};

const da_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrundelse for ekstraordinær opsigelse`)
};

const sv_consumer_declaration_extraordinary_reason = /** @type {(inputs: Consumer_Declaration_Extraordinary_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skäl för extraordinär uppsägning`)
};

/**
* | output |
* | --- |
* | "Reason for extraordinary termination" |
*
* @param {Consumer_Declaration_Extraordinary_ReasonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_extraordinary_reason = /** @type {((inputs?: Consumer_Declaration_Extraordinary_ReasonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Extraordinary_ReasonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "fr") return fr_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "es") return es_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "it") return it_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "nl") return nl_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "pl") return pl_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "fi") return fi_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "da") return da_consumer_declaration_extraordinary_reason(inputs)
	if (locale === "sv") return sv_consumer_declaration_extraordinary_reason(inputs)
	return en_consumer_declaration_extraordinary_reason(inputs)
});